{
  "header": {
    "title": "Survey overview",
    "description": "Create, manage, and analyze employee surveys to gather deeper insights",
    "createButton": "Create a survey",
    "createModal": {
      "title": "Create a survey",
      "useTemplate": {
        "title": "Use templates",
        "description": "Explore pre-built templates and customize them for your goals",
        "buttonLabel": "See templates"
      },
      "createTemplate": {
        "title": "Create from scratch",
        "description": "Create your unique survey with format you like",
        "buttonLabel": "Create survey"
      }
    },
    "unsavedChangesDialog": {
      "title": "Unsaved survey changes",
      "description": "You have unsaved changes that will be lost if you leave this page. Do you want to continue without saving?",
      "exitButton": "Exit without saving",
      "keepEditingButton": "Keep editing"
    }
  },
  "tabs": {
    "active": "Active",
    "finished": "Finished",
    "scheduled": "Scheduled",
    "drafts": "Drafts"
  },
  "searchInput": {
    "placeholder": "Search surveys"
  },
  "tagsDropdown": {
    "triggerLabel": "Tags",
    "placeholder": "Find a tag",
    "options": {
      "employeeEngagement": "Employee Engagement",
      "workplaceCulture": "Workplace Culture",
      "teamSatisfaction": "Team Satisfaction",
      "performanceFeedback": "Performance Feedback",
      "organizationalImprovement": "Organizational Improvement",
      "usa": "USA",
      "europe": "Europe",
      "asia": "Asia",
      "ukraine": "Ukraine"
    }
  },
  "builderPage": {
    "header": {
      "title": "Survey builder",
      "backButton": "Go back",
      "seePreviewButton": "See preview",
      "shareButton": "Share",
      "saveButton": {
        "label": "Save",
        "options": {
          "draft": "Save as draft",
          "template": "Save as template",
          "companyTemplate": "Save as company template"
        }
      },
      "publishButton": "Publish"
    },
    "tabs": {
      "surveySetup": {
        "title": "Survey setup",
        "coverImageSection": {
          "title": "Cover image",
          "imageUpload": "Upload an image or drop it here",
          "imageSize": "Max. 800x400 px",
          "formatImage": "PNG, JPG format",
          "titleInput": {
            "label": "Survey title",
            "placeholder": "Enter a title"
          },
          "descriptionInput": {
            "label": "Survey description",
            "placeholder": "Enter a description"
          },
          "tagsInput": {
            "label": "Survey tags",
            "placeholder": "Enter tag and hit enter"
          }
        },
        "question": {
          "title": "Question #{{questionCount}}",
          "required": "Required",
          "type": {
            "title": "Question type",
            "textType": "Text",
            "scaleType": "Scale",
            "choiceType": "Choice"
          },
          "questionInput": {
            "label": "Question",
            "placeholder": "Enter question here"
          },
          "descriptionInput": {
            "label": "Question description",
            "placeholder": "Enter question here"
          },
          "span": {
            "title": "Span",
            "to": "to"
          },
          "spanLabels": {
            "title": "Span labels",
            "placeholder": "Label (optional)"
          },

          "options": {
            "title": "Choice options",
            "placeholder": "Enter a choice",
            "addChoiceButton": "Add a choice",
            "multipleAnswers": "Multiple answers"
          },
          "addNewQuestionBUtton": "Add new question"
        },
        "cardPreview": {
          "title": "Survey card preview",
          "tabs": {
            "cover": {
              "label": "Cover",
              "time": "1-2 minutes"
            },
            "template": {
              "label": "Template",
              "time": "1-2 minutes"
            }
          }
        }
      },
      "audience": {
        "title": "Audience",
        "audienceSection": {
          "title": "Audience size"
        },
        "surveyAudienceSection": {
          "title": "Survey audience",
          "options": {
            "entireCompany": "Entire company"
          }
        },
        "segmentationSection": {
          "title": "Segmentation options",
          "selectAll": "Select all",
          "options": {
            "location": {
              "label": "Location",
              "options": {
                "us": "US",
                "europe": "Europe",
                "asia": "Asia"
              }
            },
            "department": {
              "label": "Department",
              "options": {
                "executiveTeam": "Executive team",
                "technicalTeam": "Technical team",
                "designTeam": "Design team",
                "productTeam": "Product team",
                "salesTeam": "Sales Team",
                "marketingTeam": "Marketing Team",
                "financeTeam": "Finance Team"
              }
            },
            "gender": {
              "label": "Gender",
              "options": {
                "male": "Male",
                "female": "Female"
              }
            },
            "tenure": {
              "label": "Tenure",
              "options": {
                "lessThanHalf": "<0.5 years",
                "halfToOne": "0.5–1 year",
                "oneToTwo": "1–2 years",
                "twoToFive": "2–5 years",
                "moreThanFive": "5+ years"
              }
            }
          }
        },
        "distributionSection": {
          "title": "Distribution methods",
          "options": {
            "mail": "Automated email",
            "link": "Manual link sharing"
          }
        }
      },
      "delivery": {
        "title": "Delivery",
        "startDate": {
          "label": "Start date",
          "placeholder": "Select date"
        },
        "endDate": {
          "label": "End date",
          "closeAfter": "Close after",
          "days": "days",
          "closeButton": "Don't automatically close"
        }
      },
      "translation": {
        "title": "Translation",
        "tabs": {
          "info": {
            "label": "Info"
          },
          "question": {
            "label": "Question {{questionCount}}"
          }
        }
      }
    }
  },
  "preview": {
    "header": {
      "backButton": "Survey preview",
      "publishButton": "Publish"
    },
    "question": {
      "finishSurvey": "Finish Survey",
      "nextQuestion": "Next Question",
      "previousQuestion": "Previous Question"
    }
  },
  "columns": {
    "title": "Title",
    "tags": "Tags",
    "noTags": "No tags",
    "completionRate": "Completion rate",
    "scheduledDate": "Scheduled date",
    "startDate": "Start date",
    "endDate": "End date",
    "creator": "Creator"
  },
  "detailsPage": {
    "header": {
      "backButton": "Back to Survey overview",
      "exportButton": "Export"
    },
    "surveyOverviewSection": {
      "title": "Survey overview",
      "invitedBlock": {
        "title": "Invited",
        "usersCount": "{{usersCount}} users"
      },
      "responsesBlock": {
        "title": "Responses"
      },
      "info": {
        "creator": "Creator",
        "startDate": "Start date",
        "endDate": "End date",
        "segmentation": "Segmentation",
        "distributionMethod": "Distribution method"
      }
    },
    "question": {
      "questionCount": "Question #{{questionCount}}",
      "responseCount": "{{responseCount}} responses"
    },
    "asnwersSection": {
      "title": "Answers"
    }
  }
}
